import React, { useEffect, useState, useMemo, useCallback, useRef } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useTable } from "react-table"
import Select from "react-select"
import {
  fetchNodeData,
  FetchNodeDeleteData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import sampleFile from "./sampleFile2.xlsx"
import axios from "axios"
import configure from "configure"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { TimePicker } from "antd"
import dayjs from "dayjs"

/* ===========================
   MODAL (UPDATED)
=========================== */
function QuestionModal({
  modal,
  setModal,
  question,
  setQuestion,
  category,
  setCategory,
  questionType,
  setQuestionType,
  options,
  setOptions,
  correctAnswer,
  setCorrectAnswer,
  duration,
  setDuration,
  maxScore,
  setMaxScore,
  questionId,
  setQuestionId,
  setImportModal,
  importModal = false,
  categoryOptions,
  handleSubmitQuestion,
  file,
  setFile,
}) {
  const handleOptionChange = (key, value) => {
    setOptions(prev => ({ ...prev, [key]: value }))
  }

  useEffect(() => {
    if (!modal) {
      setQuestion("")
      setCategory("")
      setQuestionType("")
      setDuration(dayjs("01:00", "mm:ss"))
      setOptions({ 1: "", 2: "", 3: "", 4: "" })
      setCorrectAnswer("")
      setMaxScore("10")
      if (questionId) setQuestionId(null)
      setImportModal(false)
    }
  }, [modal])

  useEffect(() => {
    console.log("importModal: ", importModal)
  }, [importModal])

  const format = "mm:ss"

  return (
    <Modal isOpen={modal} size={importModal ? "md" : "lg"} centered>
      <div className="modal-header">
        {importModal ? (
          <h5 className="modal-title mt-0">Import Questions</h5>
        ) : (
          <h5 className="modal-title mt-0">
            {questionId ? "Edit" : "Add"} Question
          </h5>
        )}
        <button
          type="button"
          onClick={() => {
            setModal(false)
          }}
          className="btn-modal-close"
        >
          <span aria-hidden="true" className="btn-modal-span">
            &times;
          </span>
        </button>
      </div>

      <div className="modal-body">
        <Form className="row px-3" onSubmit={handleSubmitQuestion}>
          {/* QUESTION */}
          {!importModal && (
            <div className="mb-4 col-md-12">
              <Label>
                Question<span className="text-danger"> *</span>
              </Label>
              <Input
                type="text"
                className="form-control"
                placeholder="Enter Question"
                value={question}
                onChange={e => setQuestion(e.target.value)}
                required
              />
            </div>
          )}

          {/* CATEGORY */}
          <div className={`mb-4 col-md-${importModal ? "12" : "4"}`}>
            <Label>
              Category<span className="text-danger"> *</span>
            </Label>
            <Select
              type="select"
              className="basic-multi-select"
              classNamePrefix="select"
              value={category}
              onChange={setCategory}
              options={categoryOptions}
              required
            ></Select>
          </div>

          {/* QUESTION TYPE */}
          {!importModal && (
            <>
              <div className="mb-4 col-md-4">
                <Label>
                  Question Type<span className="text-danger"> *</span>
                </Label>
                <Input
                  type="select"
                  className="form-control"
                  value={questionType}
                  onChange={e => setQuestionType(e.target.value)}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="1">MCQ</option>
                  <option value="2">Code Editor</option>
                  <option value="3">Text Input</option>
                </Input>
              </div>

              <div className="mb-4 col-md-4">
                <Label>
                  Duration <span className="text-danger">*</span>
                </Label>

                <TimePicker
                  value={duration} // ✅ dayjs only
                  format="mm:ss"
                  showHour={false}
                  showNow={false}
                  needConfirm={false}
                  placeholder="mm:ss"
                  className="w-100"
                  onChange={time => setDuration(time)} // ✅ keep dayjs
                />
              </div>

              {(questionType === "2" || questionType === "3") && (
                <div className="mb-4 col-md-4">
                  <Label>Max Score <span className="text-danger">*</span></Label>
                  <Input
                    type="number"
                    min={1}
                    max={100}
                    value={maxScore}
                    onChange={e => setMaxScore(e.target.value)}
                    required
                  />
                </div>
              )}
            </>
          )}

          {/* MCQ OPTIONS */}
          {!importModal && questionType === "1" && (
            <>
              <div className="py-3 audit_box row mx-0">
                {["1", "2", "3", "4"].map(opt => (
                  <div key={opt} className="py-2 col-md-6">
                    <Label>
                      Option {opt}
                      <span className="text-danger"> *</span>
                    </Label>
                    <Input
                      type="text"
                      placeholder={`Enter Option ${opt}`}
                      value={options[opt] || ""}
                      onChange={e => handleOptionChange(opt, e.target.value)}
                      required
                    />
                  </div>
                ))}

                <div className="mt-3 mb-2 col-md-6">
                  <Label>
                    Correct Answer<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    type="select"
                    value={correctAnswer}
                    onChange={e => setCorrectAnswer(e.target.value)}
                    required
                  >
                    <option value="">Select Correct Answer</option>
                    {["1", "2", "3", "4"].map(opt => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Input>
                </div>
              </div>
            </>
          )}

          {importModal && (
            <div className="mb-4 col-md-12">
              <Label>
                Upload Sheet<span className="text-danger"> *</span>
              </Label>
              <input
                type="file"
                className="form-control"
                onChange={e => setFile(e.target.files[0])}
                required
              />
            </div>
          )}

          <div className="mt-4">
            <button type="submit" className="border-radius btn btn-purple">
              <i className="fas fa-save me-2"></i>
              Submit
            </button>

            {importModal && (
              <button
                type="button"
                className="border-radius btn btn-primary ms-3"
                onClick={() => {
                  const link = document.createElement("a")
                  link.href = ""
                  link.href = sampleFile
                  link.download = "sampleFile.xlsx"
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }}
              >
                <i className="fas fa-download me-2"></i>
                Sample Sheet
              </button>
            )}
          </div>
        </Form>
      </div>
    </Modal>
  )
}

const fmtCount = n => (n ?? 0).toLocaleString("en-IN")

/* ===========================
   TABLE CONTAINER (UNCHANGED + ADD COLUMN)
=========================== */
const TYPE_LABEL = { 1: "MCQ", 2: "Code Editor", 3: "Text Input" }


function ServerPagination({ currentPage, totalPages, onPageChange, pageSize, totalCount }) {
  const visiblePages = 10
  const startEntry = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1
  const endEntry   = Math.min(currentPage * pageSize, totalCount)

  let startPage = Math.max(currentPage - Math.floor(visiblePages / 2), 1)
  let endPage   = startPage + visiblePages - 1
  if (endPage > totalPages) { endPage = totalPages; startPage = Math.max(endPage - visiblePages + 1, 1) }

  const pageNumbers = []
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i)

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap py-3 py-md-0">
        <p>
          Showing {startEntry} to {endEntry} of {totalCount} entries
        </p>
        <div className="d-flex align-items-md-center justify-content-md-end flex-column flex-md-row">
          <ul className="pagination m-0">
            <li
              className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              onClick={currentPage > 1 ? () => onPageChange(currentPage - 1) : undefined}
            >
              <span className="page-link">Previous</span>
            </li>
            {pageNumbers.map(p => (
              <li
                key={p}
                className={`page-item ${p === currentPage ? "bg-purple" : ""}`}
                onClick={() => onPageChange(p)}
              >
                <span className={`page-link ${p === currentPage ? "bg-purple" : ""}`}>{p}</span>
              </li>
            ))}
            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              onClick={currentPage < totalPages ? () => onPageChange(currentPage + 1) : undefined}
            >
              <span className="page-link">Next</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

function TableContainer({
  columns,
  data,
  question,
  setQuestion,
  category,
  setCategory,
  questionType,
  setQuestionType,
  options,
  setOptions,
  correctAnswer,
  setCorrectAnswer,
  duration,
  setDuration,
  maxScore,
  setMaxScore,
  categoryOptions,
  handleSubmitQuestion,
  modal,
  setModal,
  questionId,
  setImportModal,
  importModal,
  file,
  setFile,
  canAdd,
  onAddPermission,
  onImportPermission,
  filterCategory,
  setFilterCategory,
  filterType,
  setFilterType,
  allCategoryOptions,
  typeCounts,
  // server pagination props
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  searchTerm,
  onSearchChange,
}) {
  const [fixedContent, setFixedContent] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => setFixedContent(window.scrollY > 160)
    document.addEventListener("scroll", handleScroll)
    return () => document.removeEventListener("scroll", handleScroll)
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data })

  return (
    <div className="px-2">
      {/* FIXED BUTTONS */}
      <div className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"}`}>
        {canAdd && (
          <button onClick={onAddPermission} className="btn btn-purple border-radius fix-btn">
            <i className="fas fa-plus me-2"></i><span>Question</span>
          </button>
        )}
        <button onClick={() => navigate(-1)} className="btn btn-red border-radius fix-btn">
          <i className="dripicons-cross me-2 icon-center"></i><span>Cancel</span>
        </button>
      </div>

      {/* TOOLBAR */}
      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "150px" }}
            value={pageSize}
            onChange={e => onPageSizeChange(Number(e.target.value))}
          >
            {[100, 250, 500, 1000].map(size => (
              <option key={size} value={size}>Show {size}</option>
            ))}
          </select>
        </Col>

        <Col className="d-flex justify-content-end align-items-center gap-2">
          <div className="me-2">
            <div className="search-box d-inline-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="border-radius form-control"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={e => onSearchChange(e.target.value)}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            {canAdd && (
              <button className="border-radius btn btn-success" onClick={onImportPermission}>
                <i className="fas fa-download me-2 icon-size"></i>Import
              </button>
            )}
            {canAdd && (
              <button className="border-radius btn btn-purple ms-2" onClick={onAddPermission}>
                <i className="fas fa-plus me-2 icon-size"></i>Question
              </button>
            )}
            <button className="border-radius btn text-white ms-md-2 btn-red" onClick={() => navigate(-1)}>
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </button>
          </div>
        </Col>
      </Row>

      {/* STATS + FILTERS */}
      <div className="my-3 d-flex justify-content-between align-items-center gap-3 flex-wrap" style={{ background: "#fafafa", border: "1px solid #ece8f5", borderRadius: 10, padding: "10px 16px" }}>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          {[
            { label: "Total",       color: "#752a97", bg: "#f5eeff", icon: "fas fa-layer-group",  count: typeCounts?.total ?? 0 },
            { label: "MCQ",         color: "#1a73e8", bg: "#eaf1ff", icon: "fas fa-check-circle", count: typeCounts?.mcq   ?? 0 },
            { label: "Code Editor", color: "#e67e22", bg: "#fff4e6", icon: "fas fa-code",          count: typeCounts?.code  ?? 0 },
            { label: "Text Input",  color: "#27ae60", bg: "#edfbf3", icon: "fas fa-pen-nib",       count: typeCounts?.text  ?? 0 },
          ].map(({ label, color, bg, icon, count }) => (
            <div key={label} style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", border: `1.5px solid ${color}30`, borderRadius: 10, padding: "7px 14px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <i className={icon} style={{ color, fontSize: 13 }}></i>
              </div>
              <div style={{ lineHeight: 1.25 }}>
                <div style={{ fontSize: 10, color: "#888", fontWeight: 500 }}>{label}</div>
                <div style={{ fontSize: 14, fontWeight: 800, color }}>{fmtCount(count)}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div style={{ minWidth: 220 }}>
            <Select
              isClearable
              placeholder="Filter by Category..."
              value={filterCategory}
              onChange={setFilterCategory}
              options={allCategoryOptions}
              classNamePrefix="select"
              styles={{
                control: base => ({ ...base, borderRadius: 6, borderColor: "#d0c4e8", minHeight: 36, fontSize: 13 }),
                valueContainer: base => ({ ...base, padding: "0 8px" }),
              }}
            />
          </div>
          <select
            className="form-select border-radius"
            style={{ width: 150, fontSize: 13, height: 36 }}
            value={filterType}
            onChange={e => setFilterType(e.target.value)}
          >
            <option value="">All Types</option>
            <option value="1">MCQ</option>
            <option value="2">Code Editor</option>
            <option value="3">Text Input</option>
          </select>
          {(filterCategory || filterType !== "") && (
            <button className="btn btn-sm rounded-4 btn-red" onClick={() => { setFilterCategory(null); setFilterType("") }}>
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
      </div>

      {/* TABLE */}
      <Table className="table table-bordered mt-2" {...getTableProps()}>
        <thead className={fixedContent ? "fixed-setting-header" : ""}>
          {headerGroups.map((hg, i) => (
            <tr key={i} {...hg.getHeaderGroupProps()}>
              {hg.headers.map((col, idx) => (
                <th key={idx} {...col.getHeaderProps()} className={col.className}>
                  {col.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, idx) => (
                  <td key={idx} {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            )
          })}
          {rows.length === 0 && (
            <tr><td colSpan={columns.length} className="text-center text-muted py-4">No questions found.</td></tr>
          )}
        </tbody>
      </Table>

      {/* SERVER PAGINATION */}
      <Row className="justify-content-md-end justify-content-center">
        <ServerPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          pageSize={pageSize}
          totalCount={totalCount}
        />
      </Row>

      {/* MODAL */}
      <QuestionModal
        modal={modal}
        setModal={setModal}
        question={question}
        setQuestion={setQuestion}
        category={category}
        setCategory={setCategory}
        questionType={questionType}
        setQuestionType={setQuestionType}
        options={options}
        setOptions={setOptions}
        correctAnswer={correctAnswer}
        setCorrectAnswer={setCorrectAnswer}
        duration={duration}
        setDuration={setDuration}
        maxScore={maxScore}
        setMaxScore={setMaxScore}
        setImportModal={setImportModal}
        importModal={importModal}
        categoryOptions={categoryOptions}
        handleSubmitQuestion={handleSubmitQuestion}
        questionId={null}
        file={file}
        setFile={setFile}
      />
    </div>
  )
}

/* ===========================
   MAIN COMPONENT (FINAL)
=========================== */
const ASSESSMENT_MODULE_ID = 122

const QuestionsList = () => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [permissions, setPermissions] = useState({ canAdd: false, canEdit: false, canDelete: false })
  const [data, setData] = useState([])

  // server-side pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(100)
  const [totalCount, setTotalCount] = useState(0)
  const [totalPages, setTotalPages] = useState(1)
  const [serverTypeCounts, setServerTypeCounts] = useState({ total: 0, mcq: 0, code: 0, text: 0 })
  const [searchTerm, setSearchTerm] = useState("")
  const searchTimerRef = useRef(null)

  const [modal, setModal] = useState(false)
  const [editId, setEditId] = useState(null)
  const [question, setQuestion] = useState("")
  const [category, setCategory] = useState("")
  const [questionType, setQuestionType] = useState("")
  const [duration, setDuration] = useState(dayjs("01:00", "mm:ss"))
  const [options, setOptions] = useState({ 1: "", 2: "", 3: "", 4: "" })
  const [correctAnswer, setCorrectAnswer] = useState("")
  const [maxScore, setMaxScore] = useState("10")
  const [loading, setLoading] = useState(false)
  const [importModal, setImportModal] = useState(false)
  const [file, setFile] = useState(null)
  const [categoryOptions, setCategoryOptions] = useState([])
  const [filterCategory, setFilterCategory] = useState(null)
  const [filterType, setFilterType] = useState("")

  const checkPermission = (index, callback) => {
    const allowed =
      index === 3 ? permissions.canAdd :
      index === 4 ? permissions.canEdit :
      index === 5 ? permissions.canDelete : false
    if (allowed) callback()
    else setAccessDenied(true)
  }

  const fetchPermissions = async () => {
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", ASSESSMENT_MODULE_ID)
    try {
      const res = await axios({
        method: "post",
        url: `${configure.nodeApi}/user_permission`,
        data: formData,
        headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
      })
      const india = res.data.data.india
      const uk = res.data.data.uk
      setPermissions({
        canAdd: india[3] == 1 || uk[3] == 1,
        canEdit: india[4] == 1 || uk[4] == 1,
        canDelete: india[5] == 1 || uk[5] == 1,
      })
    } catch (e) {
      console.log(e)
    }
  }

  const fetchCategoryOptions = async () => {
    try {
      const response = await fetchNodeData(
        null,
        "preassesment/category/getAllCategory",
        secureLocalStorage?.getItem("auth_token")
      )
      const list = response?.data
      if (Array.isArray(list)) {
        setCategoryOptions(list.map(item => ({ value: item.id, label: item.name })))
      }
    } catch (e) {
      console.error("fetchCategoryOptions:", e)
    }
  }

  const fetchQuestions = useCallback(async (page, size, catFilter, typeFilter, search) => {
    try {
      const userId = localStorage.getItem("auth_id")
      const params = new URLSearchParams({ page, limit: size })
      if (catFilter?.value) params.append("category", catFilter.value)
      if (typeFilter)       params.append("type", typeFilter)
      if (search)           params.append("search", search)

      const response = await fetchNodeData(
        null,
        `preassesment/questions/getQuestions/${userId}?${params.toString()}`,
        secureLocalStorage?.getItem("auth_token")
      )
      if (response?.success) {
        setData(response.data ?? [])
        setTotalCount(response.total ?? 0)
        setTotalPages(response.totalPages ?? 1)
        if (response.typeCounts) setServerTypeCounts(response.typeCounts)
      }
    } catch (e) {
      console.error("fetchQuestions:", e)
    }
  }, [])

  const handleDeleteQuestions = async id => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
      })

      if (!result.isConfirmed) return

      const response = await FetchNodeDeleteData(
        setLoading,
        "preassesment/questions/deleteQuestion",
        id
      )

      const success =
        response?.data?.success ||
        response?.data?.data?.success ||
        response?.success

      if (success) {
        await Swal.fire("Success", "Question deleted successfully", "success")
        fetchQuestions(currentPage, pageSize, filterCategory, filterType, searchTerm)
      } else {
        Swal.fire("Error", "Failed to delete question", "error")
      }
    } catch (error) {
      console.error(error)
      Swal.fire("Error", "Something went wrong", "error")
    }
  }
  const typeMap = {
    1: "MCQ",
    2: "Code Editor",
    3: "Text Input",
  }

  const columns = useMemo(
    () => [
      { Header: "ID", accessor: "id", className: "text-center" },
      { Header: "Question", accessor: "question", className: "col-5" },
      { Header: "Category", accessor: "categoryname" },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ row }) => typeMap[Number(row.original.type)] || "N/A",
      },
      {
        Header: "Max Score",
        accessor: "max_score",
        className: "text-center",
        Cell: ({ row }) => {
          const t = Number(row.original.type)
          return t === 2 || t === 3
            ? <span className="badge bg-secondary">{row.original.max_score ?? 10}</span>
            : <span className="text-muted">—</span>
        },
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <div>
            {permissions.canEdit && (
              <button
                className="btn btn-sm me-1 btn-outline-secondary"
                onClick={() => {
                  checkPermission(4, () => {
                    const q = row.original
                    setEditId(q.id)
                    setQuestion(q.question)
                    setCategory({ value: q.category, label: q.categoryname })
                    setQuestionType(String(q.type))
                    setDuration(
                      q.duration
                        ? dayjs(q.duration, "mm:ss")
                        : dayjs("01:00", "mm:ss")
                    )
                    setOptions(
                      q.options
                        ? JSON.parse(q.options)
                        : { 1: "", 2: "", 3: "", 4: "" }
                    )
                    setCorrectAnswer(String(q.correct_ans))
                    setMaxScore(String(q.max_score || 10))
                    setModal(true)
                  })
                }}
              >
                <i className="fas fa-pencil-alt"></i>
              </button>
            )}
            {permissions.canDelete && (
              <button
                className="btn btn-sm btn-danger"
                onClick={() => checkPermission(5, () => handleDeleteQuestions(row.original.id))}
              >
                <i className="fas fa-trash-alt"></i>
              </button>
            )}
          </div>
        ),
      },
    ],
    [permissions]
  )

  // initial load
  useEffect(() => {
    const load = async () => {
      setLoading(true)
      await Promise.all([fetchQuestions(1, pageSize, null, "", ""), fetchCategoryOptions(), fetchPermissions()])
      setLoading(false)
    }
    load()
  }, [])

  // refetch when page/size changes
  useEffect(() => {
    fetchQuestions(currentPage, pageSize, filterCategory, filterType, searchTerm)
  }, [currentPage, pageSize])

  // reset to page 1 and refetch when filters change
  useEffect(() => {
    setCurrentPage(1)
    fetchQuestions(1, pageSize, filterCategory, filterType, searchTerm)
  }, [filterCategory, filterType])

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value)
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current)
    searchTimerRef.current = setTimeout(() => {
      setCurrentPage(1)
      fetchQuestions(1, pageSize, filterCategory, filterType, value)
    }, 400)
  }, [pageSize, filterCategory, filterType, fetchQuestions])

  const handleSubmitQuestion = async e => {
    e.preventDefault()

    const qType = parseInt(questionType)
    const payload = {
      question,
      category: category?.value,
      type: qType,
      duration: duration ? duration.format("mm:ss") : "01:00",
      options: JSON.stringify(options),
      correct_ans: correctAnswer,
      ...(qType === 2 || qType === 3 ? { max_score: parseInt(maxScore) || 10 } : {}),
    }

    try {
      let response

      if (importModal) {
        response = await axios.post(
          `${configure.nodeApi}/preassesment/questions/bulk`,
          { file, category: category?.value },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
      } else if (editId) {
        // ===== EDIT MODE =====
        response = await FetchNodePutData(
          setLoading,
          `preassesment/questions/editQuestion`,
          editId,
          payload
        )
      } else {
        // ===== ADD MODE =====
        response = await FetchNodePostData(
          setLoading,
          "preassesment/question/add",
          secureLocalStorage?.getItem("auth_token"),
          { ...payload, user_id: localStorage.getItem("auth_id") }
        )
      }

      const success =
        response?.data?.success ||
        response?.data?.data?.success ||
        response?.success

      if (success) {
        Swal.fire(
          "Success",
          editId
            ? "Question updated successfully"
            : response?.data?.data?.message || response?.data?.message || "Question added successfully",
          "success"
        )

        setModal(false)
        fetchQuestions(currentPage, pageSize, filterCategory, filterType, searchTerm)
      } else {
        Swal.fire("Error", "Operation failed", "error")
      }
    } catch (err) {
      console.error(err)
      Swal.fire("Error", "Something went wrong", "error")
    }
  }

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <TableContainer
            columns={columns}
            data={data}
            question={question}
            setQuestion={setQuestion}
            category={category}
            setCategory={setCategory}
            questionType={questionType}
            setQuestionType={setQuestionType}
            duration={duration}
            setDuration={setDuration}
            options={options}
            setOptions={setOptions}
            correctAnswer={correctAnswer}
            setCorrectAnswer={setCorrectAnswer}
            maxScore={maxScore}
            setMaxScore={setMaxScore}
            categoryOptions={categoryOptions}
            handleSubmitQuestion={handleSubmitQuestion}
            questionId={editId}
            modal={modal}
            setModal={setModal}
            importModal={importModal}
            setImportModal={setImportModal}
            file={file}
            setFile={setFile}
            canAdd={permissions.canAdd}
            onAddPermission={() => checkPermission(3, () => setModal(true))}
            onImportPermission={() => checkPermission(3, () => { setImportModal(true); setModal(true) })}
            filterCategory={filterCategory}
            setFilterCategory={v => { setFilterCategory(v) }}
            filterType={filterType}
            setFilterType={v => { setFilterType(v) }}
            allCategoryOptions={categoryOptions}
            typeCounts={serverTypeCounts}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            pageSize={pageSize}
            onPageChange={page => setCurrentPage(page)}
            onPageSizeChange={size => { setPageSize(size); setCurrentPage(1) }}
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
          />
        </Col>

        <QuestionModal
          modal={modal}
          setModal={setModal}
          question={question}
          setQuestion={setQuestion}
          category={category}
          setCategory={setCategory}
          questionType={questionType}
          setQuestionType={setQuestionType}
          options={options}
          setOptions={setOptions}
          duration={duration}
          setDuration={setDuration}
          correctAnswer={correctAnswer}
          setCorrectAnswer={setCorrectAnswer}
          maxScore={maxScore}
          setMaxScore={setMaxScore}
          questionId={editId}
          setQuestionId={setEditId}
          categoryOptions={categoryOptions}
          handleSubmitQuestion={handleSubmitQuestion}
          importModal={importModal}
          setImportModal={setImportModal}
          file={file}
          setFile={setFile}
        />
      </Row>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </div>
  )
}

export default QuestionsList
